import React from "react";
import { Provider } from "mobx-react";
import ReactDOM from "react-dom/client";
import { PrimeReactProvider } from "primereact/api";
import "./index.css";
import "./responsive/responsive.css";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import { CognitoHelper } from "./utils/cognitoHelper";
import { AuthStore } from "./store/authStore";
import { BackendAPIStore } from "./store/backendAPIStore";
import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { ResponsiveProvider } from "./responsive/ResponsiveProvider";

const cognitoHelper = new CognitoHelper();
const authStore: AuthStore = new AuthStore();
const backendAPIStore: BackendAPIStore = new BackendAPIStore(authStore);

// try {
//   const config: AwsRumConfig = {
//     sessionSampleRate: 1,
//     identityPoolId: "us-west-2:4c923ceb-db91-408f-860b-1298f9e8a71e",
//     endpoint: "https://dataplane.rum.us-west-2.amazonaws.com",
//     telemetries: ["performance", "errors", "http"],
//     allowCookies: true,
//     enableXRay: false,
//     signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
//   };

//   const APPLICATION_ID: string = '07b9eade-c7d9-4cd6-9db5-0176f6218fa9';
//   const APPLICATION_VERSION: string = '1.0.0';
//   const APPLICATION_REGION: string = 'us-west-2';

//   const awsRum: AwsRum = new AwsRum(
//     APPLICATION_ID,
//     APPLICATION_VERSION,
//     APPLICATION_REGION,
//     config
//   );
// } catch (error) {
//   // Ignore errors thrown during CloudWatch RUM web client initialization
// }

const stores = {
  authStore,
  cognitoHelper,
  backendAPIStore,
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <PrimeReactProvider
    value={{
      appendTo: typeof document !== "undefined" ? document.body : undefined,
      hideOverlaysOnDocumentScrolling: false,
    }}
  >
    <Provider {...stores}>
      <ResponsiveProvider>
        <App />
      </ResponsiveProvider>
    </Provider>
  </PrimeReactProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
